import styled from "styled-components";
import { motion } from "framer-motion";

//F8F1F1

export const primaryBtn = styled(motion.button)`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0.6rem 1.5rem;
  font-family: "Roboto", sans-serif;
  color: white;
  background: #19456b;
  border-radius: 2rem;
  border: none;
  background: white;
  font-size: 1rem;

  font-weight: bold;
  letter-spacing: 0.4px;
  box-shadow: 1px 2px 4px rgba(0, 0, 0, 0.4);

  :active {
    box-shadow: inset 0px 4px 4px rgba(0, 0, 0, 0.3);
  }
`;

export const secondaryBtn = styled(primaryBtn)`
  background: none;
  border: solid 2px white;
  color: white;
`;

export const BasicDiv = styled(motion.div)`
  display: flex;
  width: 100%;
`;

export const NavList = styled(motion.li)`
  font-weight: 500;
  letter-spacing: 0.2px;
  color: white;
  font-size: 0.9rem;
  margin: 0rem 1rem;
  padding: 0.2rem 0.5rem;

  @media (max-width: 1300px) {
    margin: 0rem 0.5rem;
  }
`;

export const InviteContainer = styled(motion.div)`
  min-height: 100vh;
  padding-top: 7.5rem;
  background: url(${(props) => props.bg});
  background-size: cover;
  display: flex;
  align-items: center;
  background-position: center;
  position: relative;
  width: 100%;
`;

export const FlexContainer = styled(motion.div)`
  display: flex;
  align-items: center;
  position: relative;
  width: 100%;

  @media (min-width: 1600px) {
    width: 100rem;
    margin: auto;
  }

  @media (max-width: 901px) {
    padding-bottom: 3rem;
    justify-content: center;
    flex-direction: column-reverse;
  }
`;
